import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { AccordionMenu } from './AccordionMenu';
import { business } from '../data/content';
import { useEstimate } from '../contexts/EstimateContext';
const navItems = [{
  label: 'Why Dany',
  href: '#why-dany'
}, {
  label: 'Services',
  href: '#services'
}, {
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'Our Promise',
  href: '#promise'
}];
const ease = [0.23, 1, 0.32, 1] as const;
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const {
    openEstimate
  } = useEstimate();
  const wrapperRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    const onClick = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onClick);
    return () => {
      window.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onClick);
    };
  }, [open]);
  return <header className="sticky top-0 z-[1100] border-b border-stone-line bg-white/95 backdrop-blur" data-id="element-332" data-mp="2jfx05vvogj79">
      <div ref={wrapperRef} className="relative mx-auto flex h-20 max-w-7xl items-center justify-between gap-6 px-5 md:px-8" data-id="element-333" data-mp="2of057gbnqpf8">
        <a href="#top" className="flex shrink-0 items-center" aria-label={`${business.name} home`} data-id="element-334" data-mp="1vs5omuhyoa71">
          <img src={business.logo} alt={business.name} className="h-16 w-auto md:h-[72px]" data-id="element-335" data-mp="20rs1v3xshqfu" />
        </a>

        <nav aria-label="Primary" className="hidden items-center gap-8 lg:flex" data-id="element-336" data-mp="25hyqh3saxay3">
          {navItems.map(item => <a key={item.href} href={item.href} className="text-sm font-medium text-ink-muted transition-colors duration-150 hover:text-forest" data-id="element-337" data-mp="183cpyq9yfo8q">
              {item.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-2" data-id="element-338" data-mp="150pz8pklnjf4">
          <button type="button" onClick={() => openEstimate()} className="hidden whitespace-nowrap rounded-md bg-brick px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-brick-dark md:inline-flex" data-id="element-339" data-mp="14zevuqv2gdoj">
            Free Estimate
          </button>
          <a href={business.phoneHref} className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-forest px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-forest-dark" data-id="element-340" data-mp="m2dt7cozipnr">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-341" data-mp="w1306afcepp8" />
            <span className="hidden sm:inline" data-id="element-342" data-mp="vy70ohnujsyo">{business.phoneDisplay}</span>
            <span className="sm:hidden" data-id="element-343" data-mp="qzvtyfsulyko">Call</span>
          </a>
          <button type="button" aria-expanded={open} aria-controls="site-menu" onClick={() => setOpen(o => !o)} className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-stone-line px-3 py-2.5 text-sm font-semibold text-forest transition-colors duration-150 hover:bg-stone-soft" data-id="element-344" data-mp="27exdijmrzj19">
            {open ? <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-345" data-mp="2f00w4tx6xlek" /> : <MenuIcon className="h-4 w-4" aria-hidden="true" data-id="element-346" data-mp="20zgcxwnd5nkj" />}
            Menu
          </button>
        </div>

        <AnimatePresence data-id="element-347" data-mp="250s4i7pssivd">
          {open && <motion.nav id="site-menu" aria-label="Site sections" initial={{
          opacity: 0,
          y: -6,
          scale: 0.98
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: -6,
          scale: 0.98
        }} transition={{
          duration: 0.18,
          ease
        }} className="absolute left-0 right-0 top-full max-h-[calc(100vh-5rem)] origin-top-right overflow-y-auto border-b border-stone-line bg-white px-5 shadow-xl sm:left-auto sm:right-5 sm:mt-2 sm:w-[380px] sm:rounded-xl sm:border md:right-8" data-id="element-348" data-mp="251tgqfijvbeo">
              <AccordionMenu onNavigate={() => setOpen(false)} data-id="element-349" data-mp="3ghrwt3c5axpe" />
            </motion.nav>}
        </AnimatePresence>
      </div>
    </header>;
}